/*************************** Action constants *******************************/

export const CREATE_LOAN_APPLICATION = "create_loan_application";
export const LOAN_APPLICATION_DETAILS = "loan_application_details";
export const LOAN_APPLICATION_BASIC_INFO_DETAILS =
  "loan_application_basic_info_details";
export const SAVE_APPLICATION_ID = "save_application_id";
export const CLEAR_LOAN_APPLICATION_DETAILS = "clear_loan_application_details";
export const RESET_BASIC_INFO = "reset_basic_info";
/***************************End of Action constants *************************/

// Const for dropdown option 'Select'
export const SELECT = "Select";

// const for year dropdown value >10
export const YEAR_GREATER_THAN_10 = {
  value: "11",
  label: "> 10",
};

// Steps of loan procedure
export const LOAN_PROCEDURE_STEPS = {
  loanApplication: 1,
  analystApproval: 2,
  loanDisbursement: 3,
};

// Steps of loan application process
export const LOAN_APPLICATION_STEPS = {
  basicAndLoanInformation: 1,
  additionalInformation: 2,
  incomeAndMonthlyExpenses: 3,
  uploadDocuments: 4,
  loanAgreement: 5,
};

// Constants for 'yes' and 'no' options
export const YES_NO_OPTIONS = {
  yes: true,
  no: false,
};

export const NA = "NA";

//constants for working partner options
export const WORKING_PARTNER_OPTIONS = {
  yes: "YES",
  no: "NO",
  na: "NA",
};

// Types of identification numbers
export const IDENTIFICATION_NUMBERS = {
  id: "DNI",
  NIE: "NIE",
};

// Constants for loan reasons
export const LOAN_REASONS_VALUES = {
  furnitureReformsOrHomeEquipment: "Furniture, reforms or home equipment",
  repairOfAVehicle: "Repair of a vehicle",
  buyACarOrMotorbike: " Buy a car / motorbike",
  sendMoney: "Send money",
  unifyDebts: "Unify debts",
  dentalOrMedicalExpenses: "Dental or medical expenses",
  educationOrTraining: "Education or training",
  celebrations: "Celebrations",
  leisureOrtravel: "Leisure or travel",
  other: "Other",
};

// Array to fill dropdown
export const LOAN_REASONS_DROPDOWN = [
  {
    value: null,
    name: "Seleccionar",
  },
  {
    value: LOAN_REASONS_VALUES.furnitureReformsOrHomeEquipment,
    name: "Muebles, reformas o equipamiento hogar",
  },
  {
    value: LOAN_REASONS_VALUES.repairOfAVehicle,
    name: "Reparación de un vehículo",
  },
  {
    value: LOAN_REASONS_VALUES.buyACarOrMotorbike,
    name: "Comprar un coche /moto",
  },
  {
    value: LOAN_REASONS_VALUES.sendMoney,
    name: "Enviar dinero",
  },
  {
    value: LOAN_REASONS_VALUES.unifyDebts,
    name: "Unificar deudas",
  },
  {
    value: LOAN_REASONS_VALUES.dentalOrMedicalExpenses,
    name: "Dental o Gastos médicos",
  },
  {
    value: LOAN_REASONS_VALUES.educationOrTraining,
    name: "Educación o formación",
  },
  {
    value: LOAN_REASONS_VALUES.celebrations,
    name: "Celebraciones",
  },
  {
    value: LOAN_REASONS_VALUES.leisureOrtravel,
    name: "Ocio o Viajes",
  },
  {
    value: LOAN_REASONS_VALUES.other,
    name: "Otros",
  },
];

//Constants fro bank name values
const BANK_NAMES_VALUES = {
  Santander: "Santander",
  BBVA: "BBVA",
  Caixabank: "Caixabank",
  Bankia: "Bankia",
  Sabadell: "Sabadell",
  Bankinter: "Bankinter",
  Unicaja: "Unicaja",
  Ibercaja: "Ibercaja",
  Kutxabank: "Kutxabank",
  Abanca: "Abanca",
  Liberbank: "Liberbank",
  ING: "ING",
  DeucheBank: "Deuche Bank",
};

//Constants fro bank name dropdown
export const BANK_NAMES_DROPDOWN = [
  {
    value: null,
    name: "Seleccionar",
  },
  {
    value: BANK_NAMES_VALUES.Santander,
    name: "Santander",
  },
  {
    value: BANK_NAMES_VALUES.Abanca,
    name: "Abanca",
  },
  {
    value: BANK_NAMES_VALUES.Bankia,
    name: "Bankia",
  },
  {
    value: BANK_NAMES_VALUES.Bankinter,
    name: "Bankinter",
  },
  {
    value: BANK_NAMES_VALUES.BBVA,
    name: "BBVA",
  },
  {
    value: BANK_NAMES_VALUES.Caixabank,
    name: "Caixabank",
  },
  {
    value: BANK_NAMES_VALUES.Unicaja,
    name: "Unicaja",
  },
  {
    value: BANK_NAMES_VALUES.DeucheBank,
    name: "Deuche Bank",
  },
  {
    value: BANK_NAMES_VALUES.Ibercaja,
    name: "Ibercaja",
  },
  {
    value: BANK_NAMES_VALUES.ING,
    name: "ING",
  },
  {
    value: BANK_NAMES_VALUES.Kutxabank,
    name: "Kutxabank",
  },
  {
    value: BANK_NAMES_VALUES.Liberbank,
    name: "Liberbank",
  },
  {
    value: BANK_NAMES_VALUES.Sabadell,
    name: "Sabadell",
  },
];

//Constants for type of employment situation.
const EMPLOYMENT_SITUATION = {
  fixedContract: "Fixed contract",
  temporaryContract: "Temporary contract",
  selfEmployed: "Self employed",
  unemployedWithBenefit: "Unemployed with benefit",
  unemployedWithoutBenefit: "Unemployed without benefit",
};

export const EMPLOYMENT_SITUATION_DROPDOWN = [
  {
    value: null,
    name: "Seleccionar",
  },
  {
    value: EMPLOYMENT_SITUATION.fixedContract,
    name: "Contrato fijo",
  },
  {
    value: EMPLOYMENT_SITUATION.temporaryContract,
    name: "Contrato temporal",
  },
  {
    value: EMPLOYMENT_SITUATION.selfEmployed,
    name: "Por cuenta propia",
  },
  {
    value: EMPLOYMENT_SITUATION.unemployedWithBenefit,
    name: "Desempleado con prestación",
  },
  {
    value: EMPLOYMENT_SITUATION.unemployedWithoutBenefit,
    name: "Desempleado sin prestación",
  },
];

//Constants for type of housing
const TYPE_OF_HOUSING = {
  ownWithMortgage: "Own with mortgage",
  ownWithoutMortgage: "Own without mortgage",
  rentHousing: "Rent housing",
  rentalRoom: "Rental room",
  houseOfARelative: "House of a relative",
  others: "others",
};

//Dropdown for type of housing
export const TYPE_OF_HOUSING_DROPDOWN = [
  {
    value: null,
    name: "Seleccionar",
  },
  {
    value: TYPE_OF_HOUSING.ownWithMortgage,
    name: "Propia con hipoteca",
  },
  {
    value: TYPE_OF_HOUSING.ownWithoutMortgage,
    name: "Propia sin hipoteca",
  },
  {
    value: TYPE_OF_HOUSING.rentHousing,
    name: "Alquiler vivienda",
  },
  {
    value: TYPE_OF_HOUSING.rentalRoom,
    name: "Alquiler habitacion",
  },
  {
    value: TYPE_OF_HOUSING.houseOfARelative,
    name: "Casa de un familiar",
  },
  {
    value: TYPE_OF_HOUSING.others,
    name: "Otros",
  },
];

// Constants for relationship to remittance receiver
export const RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES = {
  mother: "Mother",
  son: "Son",
  girlfriend: "Girlfriend",
  sister: "Sister",
  brother: "Brother",
  friend: "Friend",
  aunt: "Aunt",
  grandmotherGrandFather: "Grandmother / Grandfather",
  otherFamilyMember: "Other family member",
};

// Array to fill dropdown of relationship to remittance receiver
export const RELATIONSHIP_TO_REMITTANCE_RECEIVER_DROPDOWN = [
  {
    value: SELECT,
    label: "Seleccionar",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.mother,
    label: "Madre",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.son,
    label: "Hijo",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.girlfriend,
    label: "Novia",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.sister,
    label: "Hermana",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.brother,
    label: "Hermano",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.friend,
    label: "Amigo",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.aunt,
    label: "Tía",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.grandmotherGrandFather,
    label: "Abuela / abuelo",
  },
  {
    value: RELATIONSHIP_TO_REMITTANCE_RECEIVER_VALUES.otherFamilyMember,
    label: "Otro miembro de la familia",
  },
];

// Values for dropdown
export const HOME_OWNER_TYPE = {
  renter: "Renter",
  owner: "Owner",
};

// Values for Loan Pay State
export const LOAN_PAY_STATE = {
  wellPaid: "Well paid",
  lateRepayments: "Late repayments",
};

// Payment Mode
export const PAYMENT_MODE = {
  directDeposit: "Direct deposit",
  cash: "Cash",
};

// Handle payment
export const CHECK_PROCESSING = {
  yes: true,
  no: false,
};

// Loan Index
export const LOAN_INDEX = {
  firstLoan: 1,
  secondLoan: 2,
  thirdLoan: 3,
};

// Selected action for loan application
export const ACTION = {
  cancel: 1,
  back: 2,
  submit: 3,
  approve: 4,
  incomplete: 5,
  reject: 6,
  disbursementBack: 7,
  disbursed: 8,
};

export const RECEIPT_TYPES = {
  submit: "SUBMIT",
  disburse: "DISBURSE",
  collection: "COLLECTION",
  paymentReceipt: "UPLOADED_COLLECTION_RECEIPT",
};

export const EMI_OPTIONS = {
  emi: "EMI",
  advanceEmi: "ADVANCE_EMI",
  advancePayment: "ADVANCE_PAYMENT",
};

export const BASIC_INFO = [
  { key: "customerUniqueId", value: "customerUniqueId" },
  { key: "fullName", value: "fullName" },
  { key: "documentType", value: "documentType" },
  { key: "documentNumber", value: "documentNumber" },
];

export const BASIC_INFO1 = [
  { key: "documentExpirationDate", value: "documentExpirationDate" },
  { key: "documentImages", value: "documentImages" },
  { key: "telephoneNumber", value: "telephoneNumber" },
  { key: "email", value: "email" },
];

export const BASIC_INFO2 = [
  { key: "profession", value: "profession" },
  { key: "dateOfBirth", value: "dateOfBirth" },
  { key: "address", value: "address" },
  { key: "nationality", value: "nationality" },
];

export const LOAN_INFO = [
  { key: "amtReq", value: "amountRequested" },
  { key: "trmReq", value: "termRequested" },
  { key: "loanUse", value: "howDoYouPlanToUseYourLoan" },
];

export const ADDITIONAL_INFO = [
  { key: "eurStay", value: "howLongHaveYouLivedInSpain" },
  {
    key: "formalInformalLoan",
    value: "haveYouHadAFormalOrInformalLoanInThePast6Months",
  },
  { key: "remitFreq", value: "frequencyOfRemittanceSending" },
  { key: "remitRelation", value: "relationshipToRemittanceReceiver" },
  { key: "ref1", value: "give2PersonalReferences" },
  { key: "ref2", value: "give2PersonalReferences" },
  { key: "housingType", value: "typeOfHousing" },
  {
    key: "finResponsible",
    value: "howManyPeopleAreYouFinanciallyResponsibleOf",
  },
];

export const INCOME_INFO = [
  { key: "job1", value: "companyName" },
  { key: "job2", value: "companyName" },
  { key: "anotherIncome", value: "doYouHaveAnotherSourceOfIncome" },
  { key: "total", value: "whatIsYourTotalAverageIncome" },
  { key: "partnerWork", value: "workingPartner" },
];

export const EXPENSES_INFO = [
  { key: "housing", value: "housingExpenses" },
  { key: "carTransport", value: "carTransportation" },
  { key: "phn", value: "phone" },
  { key: "amenities", value: "amenities" },
  { key: "food", value: "food" },
  { key: "remittance", value: "remittance" },
  { key: "loanCredit", value: "loanRepaymentOrCreditCardExpenses" },
  { key: "other", value: "otherExpenses" },
];
